import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { jwtDecode } from 'jwt-decode';
import { SignUpStorageKey, ForgetPasswordStorageKey, LoginStorageKey, TfaStorageKey } from '../_helpers/auth.constants';
const { USER_KEY } = environment;

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {
  }

  clean(): void {
    localStorage.clear()
  }

  public saveUserData(user: any): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    // Decode JWT and store userKey and username
    const decodedToken = this.decodeJWT(user.accessToken);
    if (decodedToken) {
      localStorage.setItem('userKey', decodedToken.userKey);
      localStorage.setItem('userName', decodedToken.username);
      localStorage.setItem('securityType', decodedToken.securityType);
      localStorage.setItem('emailId', decodedToken.username);
    }
  }

  public getUser(): any {
    const user = localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  public getUserName(): any {
    const user = localStorage.getItem('user');
    if (user) {
      return user;
    }
    return {};
  }
  public getUserId(): any {
    const userId = localStorage.getItem('userKey');
    if (userId) {
      return userId;
    }
    return {};
  }

  public isLoggedIn(): boolean {
    const user = localStorage.getItem(USER_KEY);
    // console.log("StorageService isLoggedIn() Called............");
    // console.log(!!user);
    return !!user;

  }

  public getToken(): string {
    const user: any = localStorage.getItem(USER_KEY);
    const userObj = JSON.parse(user);
    return userObj?.accessToken || userObj?.token || null
  }

  public saveMenuItems(data: any): any {
    localStorage.setItem('menuItems', JSON.stringify(data));
  }

  public getMenuItems(): any {
    const menuString = localStorage.getItem('menuItems');
    return JSON.parse(menuString || "{}");
  }

  public setEncKey(encKey: string): void {
    localStorage.setItem('functionId', encKey);
  }

  public getEncKey(): string {
    return localStorage.getItem('functionId') || '';
  }

  isJwtExpired(): boolean {
    try {
      const decoded: any = jwtDecode(this.getToken());
      const currentTime = Date.now() / 1000;
      return decoded.exp < currentTime;
    } catch (error) {
      console.error("Invalid JWT:", error);
      return true;
    }
  }

  public decodeJWT(token: string): any {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding JWT:', error);
      return null;
    }
  }

  // ============================================
  // OTP Verification Storage Methods
  // ============================================

  /**
   * Get a value from localStorage for OTP verification flow
   * @param key - Storage key to retrieve
   * @returns The stored value or null if not found
   */
  public getForVerifyOTP(key: SignUpStorageKey | LoginStorageKey | ForgetPasswordStorageKey | TfaStorageKey): string | null {
    return localStorage.getItem(key);
  }

  /**
   * Set a value in localStorage for OTP verification flow
   * @param key - Storage key to set
   * @param value - Value to store
   */
  public setForVerifyOTP(key: SignUpStorageKey | LoginStorageKey | ForgetPasswordStorageKey | TfaStorageKey, value: string): void {
    localStorage.setItem(key, value);
  }

  /**
   * Remove a value from localStorage for OTP verification flow
   * @param key - Storage key to remove
   */
  public removeForVerifyOTP(key: SignUpStorageKey | LoginStorageKey | ForgetPasswordStorageKey | TfaStorageKey): void {
    localStorage.removeItem(key);
  }

  public clearAllVerifyOTPStorage(): void {
    Object.values(SignUpStorageKey).forEach(key => localStorage.removeItem(key));
    Object.values(LoginStorageKey).forEach(key => localStorage.removeItem(key));

  }

  /**
   * Clear all OTP verification related storage keys for forgot password flow
   */
  public clearAllForgotPasswrodOTPStorage(): void {
    Object.values(ForgetPasswordStorageKey).forEach(key => localStorage.removeItem(key));
  }
}